/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */

/**
 * Current status of the MQTT user
 */
export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

export const UserStatus = {
  ACTIVE: 'active',
  PAUSED: 'paused',
} as const;
